import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';

import { rootApi } from './rootApi';
import rootReducer from './rootReducer';

const devMode = window.REACT_APP_NODE_ENV === 'development';

export const store = configureStore({
    reducer: rootReducer,
    devTools: devMode,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: [],
                ignoredActions: [],
            },
        }).concat(rootApi.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = Omit<ReturnType<typeof store.getState>, 'rootApi'>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
